var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#323130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    rx: 2,
    fill: "inherit"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8639 5.65609C16.0533 5.85704 16.0439 6.17348 15.8429 6.36288L7.91309 13.8368C7.67573 14.0605 7.30311 14.0536 7.07417 13.8213L4.39384 11.1009C4.20003 10.9042 4.20237 10.5877 4.39907 10.3938C4.59578 10.2 4.91235 10.2024 5.10616 10.3991L7.51192 12.8407L15.1571 5.63517C15.358 5.44577 15.6745 5.45513 15.8639 5.65609Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.cc11b0eed3b81515dc6f08aa91ae93ab.svg";
export { ForwardRef as ReactComponent };